import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import AlertsActionsSelect from '@/components/inputs/AlertsActionsSelect.vue';
import { FormValues } from './model';
import { computed, reactive } from 'vue';
import { AlertAction } from '@/models/enums/AlertsEnums';
import { maxLength, required, requiredIf, sameAs } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { helpers, not } from '@vuelidate/validators';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationContentWizardStep',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', formValues: FormValues) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: FormValues;
};





const { t } = useI18n();

const state = reactive({
  formValues: props.value,
});
const validations = computed(() => ({
  formValues: {
    alertAction: {
      required: helpers.withMessage(
        () => t('form.select_validation').toString(),
        not(sameAs(AlertAction.None)),
      ),
    },
    emailSubject: {
      required: requiredIf(
        () => state.formValues.alertAction === AlertAction.WebAndEmail,
      ),
      maxLength: maxLength(64),
    },
    message: {
      required,
      maxLength: maxLength(1024),
    },
  },
}));
const v$ = useVuelidate(validations, state);

function onInput() {
  emit('input', state.formValues);
}

function onAlertActionInput() {
  if (state.formValues.alertAction !== AlertAction.WebAndEmail) {
    state.formValues.emailSubject = '';
  }
  onInput();
}

const subjectValidationMessage = computed(() => {
  return v$.value.formValues.emailSubject.$errors[0]?.$message;
});

const messageValidationMessage = computed(() => {
  return v$.value.formValues.message.$errors[0]?.$message;
});

return { __sfc: true,props, emit, t, state, validations, v$, onInput, onAlertActionInput, subjectValidationMessage, messageValidationMessage, WizardStep, AlertsActionsSelect, AlertAction }
}

})